
import { useTranslatedText } from "@/hooks/useTranslate";
import { Globe, TrendingUp, ShieldCheck, BarChart3 } from "lucide-react";

const BusinessSection = () => {
  const titleText = useTranslatedText("Eleva tu Negocio");
  const subtitleText = useTranslatedText("En la era digital actual, tener un sitio web es más que una conveniencia, es una necesidad para cualquier negocio o entidad que busque destacar y prosperar en línea.");

  const benefit1Title = useTranslatedText("Visibilidad Global");
  const benefit1Desc = useTranslatedText("Abre las puertas a audiencias globales las 24 horas del día. Expandiendo tu alcance para atraer clientes de todo el mundo");
  const benefit2Title = useTranslatedText("Marketing eficiente");
  const benefit2Desc = useTranslatedText("Un sitio web es esencial para estrategias de marketing digital exitosas, incluyendo SEO y redes sociales, para atraer y retener clientes de manera efectiva.");
  const benefit3Title = useTranslatedText("Credibilidad");
  const benefit3Desc = useTranslatedText("Un sitio web profesional genera confianza en los consumidores modernos. Influencia positivamente sus decisiones de compra al crear una impresión positiva.");
  const benefit4Title = useTranslatedText("Optimización");
  const benefit4Desc = useTranslatedText("Rastrea el comportamiento de los visitantes y ajusta estrategias basadas en datos para mejorar continuamente tu presencia en línea.");

  const benefits = [
    { icon: <Globe className="w-10 h-10" />, title: benefit1Title, description: benefit1Desc, stat: "24/7" },
    { icon: <TrendingUp className="w-10 h-10" />, title: benefit2Title, description: benefit2Desc, stat: "300%" },
    { icon: <ShieldCheck className="w-10 h-10" />, title: benefit3Title, description: benefit3Desc, stat: "95%" },
    { icon: <BarChart3 className="w-10 h-10" />, title: benefit4Title, description: benefit4Desc, stat: "10x" },
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Vibrant gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-techno-dark via-[#12082e] to-techno-dark"></div>
      <div className="absolute inset-0 hero-grid opacity-20"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-techno-purple mb-6">{titleText}</h2>
          <p className="text-gray-300 text-lg max-w-4xl mx-auto leading-relaxed">{subtitleText}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="glass-strong rounded-2xl p-8 hover:border-techno-purple/40 transition-all duration-500 group animate-fade-in hover:scale-[1.02] hover:-translate-y-1"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="flex items-start gap-5">
                <div className="text-techno-purple group-hover:scale-110 transition-transform duration-300 shrink-0 mt-1">
                  {benefit.icon}
                </div>
                <div className="space-y-3 flex-1">
                  <div className="flex items-center justify-between">
                    <h3 className="text-2xl font-bold text-white group-hover:text-techno-purple transition-colors duration-300">
                      {benefit.title}
                    </h3>
                    <span className="text-3xl font-bold text-techno-accent/60">{benefit.stat}</span>
                  </div>
                  <p className="text-gray-400 leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-techno-purple/40 to-transparent"></div>
    </section>
  );
};

export default BusinessSection;
